// Canonical table-alias normaliser — the single key space used by the jobchain.
//
// Extracted verbatim from JobchainV1_1.normalizeAlias (which now delegates here)
// so anything keying data by table uses the SAME key the jobchain uses for
// jobStore.tables. Writing under a raw `job.alias` (e.g. "3") while the jobchain
// keys the table "T3" produces a node nobody reads and nothing ever clears.
//
// Behaviour (do not change without changing the jobchain):
//   - "โต๊ะ 7" / "Table 7" → "T7"
//   - bare-numeric alias on a TABLE-mode, non-app2 job → T-prefixed ("3" → "T3")
//   - TOGO / JOB / DELIVERY aliases (queue numbers) are left alone
export function normalizeTableAlias(rawAlias: any, job: any): string {
    let alias = (rawAlias ?? '')
        .toString()
        .replace('โต๊ะ ', 'T')
        .replace('Table ', 'T')

    // Table mode only — TOGO / service (JOB) / DELIVERY aliases (queue
    // numbers etc.) must NOT be T-prefixed. Absent mode defaults to table
    // (matches _generateTableObj's `job.mode || 1`).
    const mode = Number(job?.mode)
    const isTableMode = !mode || mode === 1 // JobMode.TABLE

    // old-version job (no v / not app2) with a bare-number alias (no zone
    // prefix) → prefix T so it matches the modern format, e.g. 3 -> T3
    const isApp2 = String(job?.v ?? '').toLowerCase() === 'app2'
    if (isTableMode && !isApp2 && /^\d+$/.test(alias)) {
        alias = 'T' + alias
    }

    return alias
}
